import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0108MState, IOffItemState} from '../../models/com/com0108m_model';
  
const initialState: ICom0108MState = {
    offList : [],      // 휴가목록
    
    pageSize  : 20,     // 페이징건수
    current   : 0,      // 현재페이지
}

export const com0108m_Slice = createSlice({
    name: "com0108m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setOffList: (state, action:PayloadAction<IOffItemState[]>) => {
            state.offList = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default com0108m_Slice.reducer;
export const Com0108mAction  = com0108m_Slice.actions;
export const Com0108mReducer = com0108m_Slice.reducer;